import Box from "@mui/material/Box";
import { isToday } from "date-fns";
import { useContext } from "react";
import { UserAvatar } from "../../components/Avatar/UserAvatar";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { useMsg } from "../../components/Msg/Msg";
import { P } from "../../components/Typography";
import { generalMessages } from "../../components/messages";
import { gray500, gray900, primary500 } from "../../theme";
import { formatName } from "../Coaches/coach.utils";
import { I18nContext } from "../I18n/I18nProvider";
import { sessionsMessages } from "../Sessions/messages";

const ScheduledDay = ({ id, isPrivate, time, name, username }) => {
  const { i18n } = useContext(I18nContext);
  const msg = useMsg({ dict: sessionsMessages });
  const generalMsg = useMsg({ dict: generalMessages });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <P
        sx={{
          fontSize: 14,
          color: isToday(time) ? primary500 : gray500,
          fontWeight: isToday(time) ? 600 : 400,
        }}
      >
        {i18n
          .formatLocal(
            time,
            isToday(time)
              ? `'${generalMsg("general.today")}, 'PPP`
              : "cccc', 'PPP",
          )
          ?.replace(i18n.formatLocal(time, "y"), "")}
      </P>
      <Box
        sx={{
          // pl: 4,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            height: "100%",
            flexBasis: "24px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            flexShrink: 100,
          }}
        >
          <Box
            sx={{
              borderRight: `4px solid ${isPrivate ? "#EAAA08" : primary500}`,
              borderRadius: "4px",
              height: "100%",
            }}
          />
        </Box>
        {!isPrivate && (
          <UserAvatar
            username={username}
            fullName={name}
            sx={{ width: 38, height: 38 }}
          />
        )}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <P sx={{ fontSize: 14, color: gray900, fontWeight: 600 }}>
            {name || username || msg("sessions.type.USER_SESSION")}
          </P>
          <P sx={{ fontSize: 14, color: gray500, fontWeight: 400 }}>
            {i18n.formatLocal(time, "p")}
          </P>
        </Box>
      </Box>
    </Box>
  );
};

export const UpcomingSessions = ({ data }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        gap: 3,
        px: 3,
        py: 3,
        height: "100%",
      }}
    >
      {data.map(({ username, firstName, lastName, time, id, isPrivate }) => (
        <ErrorBoundary key={time + username}>
          <ScheduledDay
            id={id}
            key={time + username}
            name={formatName({ firstName, lastName })}
            username={username}
            time={time}
            isPrivate={isPrivate}
          />
        </ErrorBoundary>
      ))}
    </Box>
  );
};
